export const sensorType = {
  soil_moisture_sensor: "soil_moisture_sensor",
  water_counter: "water_counter",
  groundwater_sensor: "groundwater_sensor",
  weather_station: "weather_station",
  pump_valve_controller: "pump_valve_controller",
  tree_sensor: "tree_sensor",
};
